module.exports = __webpack_public_path__ + "static/img/logo1.b73dd07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo1.png
// module id = Byuk
// module chunks = 24